<template>
    <div>
         <p class="bigTitle"><span class="floor">*</span>商品管理>售卖规则</p>
         <div class="body">
             <el-button type="primary" class="batchButtom">新建规则</el-button><br/>
             <div class="search">
                 <div class="block">
                        <span class="searchTime">售卖规则:</span>
                        <el-input v-model="input" class="searchInput" placeholder="请输入商品名"></el-input>
                        <span class="searchName">规则状态:</span>
                        <el-input v-model="input" class="searchInput" placeholder="请输入商品名"></el-input>
                        <el-button type="primary" class="searchButtom">搜索</el-button>
                </div>
             </div>
             <!-- 标题 -->
            <div class="excle">
                <div class="title">
                    <el-table
                        :data="tableData"
                        style="width: 98%;margin-bottom: 20px;background-color: #0F86DA"
                        row-key="id"
                        border = false
                        :header-cell-style="tableHeaderColor"
                        :tree-props="{ hasChildren: 'hasChildren',children: 'children'}">
                        <el-table-column  prop="date"  label="商品名称" width="300" background-color="#0F86DA"> </el-table-column>
                        <el-table-column  prop="address" label="所属房型房号">高级双床房</el-table-column>
                        <el-table-column  prop="address" label="价格">$266</el-table-column>
                        <el-table-column  prop="address" label="活动时间">2020/04/10----2020/04/25</el-table-column>
                        <el-table-column  prop="address" label="是否有效">有效 </el-table-column>
                        <el-table-column  prop="address" label="操作">设为无效 | 编辑</el-table-column>
                     </el-table>
                </div>
            </div>

         </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        inputs: 226,
        //表格
        tableData: [{
          id: 2,
          date: '高级双床房',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          id: 3,
          date: '豪华大床房',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          children: [{
              id: 31,
              date: '豪华大床房-2份早餐-免费取消',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
            }, {
              id: 32,
              date: '豪华大床房-入住日18:00前可免费取消',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
          }]
        }, {
          id: 4,
          date: '小单间',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }, {
          id: 5,
          date: '豪华大床房',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          children: [{
              id: 31,
              date: '豪华大床房-2份早餐-免费取消',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
            }, {
              id: 32,
              date: '豪华大床房-入住日18:00前可免费取消',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
          }]
        }],

      };
    },
    methods: {
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #409EFF;color: #fff'
      }
    }
  }
  };
</script>

<style scoped>

.bigTitle{
    text-align: left;
}

.floor{
    width: 15px;
    background-color: #0F86DA;
    color:#0F86DA;
    border-radius: 5px;
}

.body{
    background-color: #FFFFFF;
    border-radius: 10px;
}

.batchButtom{
    margin-top: 1%;
    margin-right: 90%;
    margin-bottom: 1%;
}

.searchName{
    margin-left: 2%;
}

.searchButtom{
   margin-right: 60%;
   margin-bottom: 1%;
}

.searchInput{
    width: 10%;
}

.saveButtom{
    margin-bottom: 1%;
}

.table{
    margin-left: 1%;
}

.thead{
    width: 100%;
}

.thOne{
    width: 10%;
    background-color: #409EFF;
}
.thName{
    width: 20%;
    color: #FFFFFF;
    background-color: #409EFF;
     height:50px;
}

.thDay{
    width: 160px;
    color: #FFFFFF;
    background-color: #409EFF;
    text-align: center;
}

.trTime{
    width: 160px;
    text-align: center;
}
.trDay{
    text-align: center;
}

.title{
    margin-left: 1%;
}

.tableInput{
    height: 30px;
    border-radius: 5px;
}

</style>


// WEBPACK FOOTER //
// src/components/Hotel/product/houseState/houseRule.vue